import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import BoostPage from './components/BoostPage';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function AppContent() {
  const [authToken, setAuthToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const exchangeCodeForToken = async (code) => {
    try {
      const response = await fetch(`https://api.vmp.ir/dev/api.php?work=login&code=${code}`);
      const data = await response.text();
      
      if (data && data.trim()) {
        return data.trim();
      }
      throw new Error('Invalid response from auth API');
    } catch (error) {
      console.error('Failed to exchange code for token:', error);
      return null;
    }
  };

  const handleTokenExpiration = () => {
    localStorage.removeItem('vmp_auth_token');
    setAuthToken(null);
  };

  useEffect(() => {
    const handleAuth = async () => {
      const existingToken = localStorage.getItem('vmp_auth_token');
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const returnUrl = localStorage.getItem('vmp_return_url');
      
      if (code && state === '1') {
        const token = await exchangeCodeForToken(code);
        if (token) {
          localStorage.setItem('vmp_auth_token', token);
          setAuthToken(token);
          
          // If there's a return URL, redirect to it (same-origin only)
          if (returnUrl) {
            localStorage.removeItem('vmp_return_url');
            try {
              const safeUrl = new URL(returnUrl, window.location.origin);
              if (safeUrl.origin === window.location.origin) {
                window.location.href = safeUrl.toString();
                return;
              }
            } catch (e) {}
          }
          
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          console.error('Failed to obtain authorization token');
        }
      } else if (existingToken) {
        setAuthToken(existingToken);
      }
      
      setLoading(false);
    };

    handleAuth();
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }


  return (
    <div className="App">
      <Routes>
        <Route 
          path="/" 
          element={authToken ? 
            <Dashboard authToken={authToken} onTokenExpiration={handleTokenExpiration} /> : 
            <LoginPage />
          } 
        />
        <Route 
          path="/boost/:id" 
          element={
            <ProtectedRoute authToken={authToken}>
              <BoostPage authToken={authToken} onTokenExpiration={handleTokenExpiration} />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;